import { Avatar, Tag, Typography } from '../../designComponents';
import { VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

type Props = {
  user: string;
  userName: string;
  email: string;
  role: string;
};
const ClientInformationVertical = ({ user, userName, email, role }: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="section-title"
        fontColor="secondary"
        strong
      >
        {user.toUpperCase()} INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Avatar size="xl" src={''} />
          <Typography fontColor="dark">{userName}</Typography>
          <Typography fontColor="border">{email}</Typography>
          <Tag type="caution">{role}</Tag>
        </div>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default ClientInformationVertical;
